<form *ngIf="form" [formGroup]="form" class="p-3 border rounded">
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('paymentTypeProvider')"
                [config]="formConfiguration.paymentTypeProvider">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('providerPartnersId')" [config]="formConfiguration.providerPartnersId">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('paymentProviderUid')" [config]="formConfiguration.paymentProviderUid">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('providerEfectivoId')" [config]="formConfiguration.providerEfectivoId">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('expenseAccountProvider')"
                [config]="formConfiguration.expenseAccountProvider">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('accountNumberProvider')"
                [config]="formConfiguration.accountNumberProvider"></app-input>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('taxProviderUid')" [config]="formConfiguration.taxProviderUid">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('taxProviderSecondUid')"
                [config]="formConfiguration.taxProviderSecondUid">
            </app-select>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('expirationProvider')"
                [config]="formConfiguration.expirationProvider"></app-input>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-checkbox [formControl]="form.get('arrendador')" [config]="formConfiguration.arrendador"></app-checkbox>
        </div>
        <div class="col-md-4 col-lg-6 col-xs-12">
            <app-input [formControl]="form.get('referencia_catastro')"
                [config]="formConfiguration.referencia_catastro"></app-input>
        </div>

    </div>
</form>